import _ from 'lodash'
import { DialogId, DialogSchema } from '@feedyou-ai/feedbot-schema'
import { Dictionary, isNotEmptyElement, mergeSets } from '@feedyou/utils'
import { NodeHierarchyMap } from '../../../lib/createNodeHierarchyMap'

export const onlyKeepTargetDialogsAndTheirDescendants = (
  dialogsToFilter: Dictionary<DialogId, DialogSchema>,
  targetIds: DialogId[] | Set<DialogId>,
  hierarchyMap: NodeHierarchyMap
): Dictionary<DialogId, DialogSchema> => {
  const idsToKeep = mergeSets(
    [...targetIds].map(id => hierarchyMap.get(id)?.descendants)?.filter(isNotEmptyElement)
  )

  return _.pick(dialogsToFilter, ...idsToKeep)
}
